import { Outlet } from "react-router-dom";

export default function EmployeeReleaseOutlet() {
  return <Outlet />;
}
